import React, {useMemo, useCallback} from "react"
import {useSelector, useDispatch} from "react-redux"

import LeftPanelBtn from "../LeftPanelBtn/LeftPanelBtn"

import {setLeftWorkAreaState} from "../../../redux/actions/product2dActions"

import "./leftpanelcontainer.scss"

/**
 * Left Panen container for mapping buttons
 * @component
 * @example
 * return <LeftPanelContainer/>
 */

const LeftPanelContainer = () => {
  const LWAState = useSelector(state => state.LWAState)
  const makFabric = useSelector(state => state.makFabric)
  const dispatch = useDispatch()

  const handleClick = useCallback(
    e => {
      ;(makFabric.getSelectedImg() || makFabric.getSelectedText()) &&
        makFabric.discradSelected()
      dispatch(setLeftWorkAreaState(e.target.dataset.value))
    },
    [dispatch, makFabric],
  )

  const renderBtns = useMemo(
    () =>
      settings.map(item => (
        <LeftPanelBtn
          key={item.value}
          icon={item.icon}
          title={item.title}
          value={item.value}
          active={LWAState && LWAState === item.value}
          handler={handleClick}
        />
      )),
    [LWAState, handleClick],
  )

  return <div className="leftPanelContainer">{renderBtns}</div>
}

export default LeftPanelContainer

const settings = [
  {
    title: "Size",
    value: "SIZE",
    icon: "/assets/img/icons/size_icn.svg",
  },
  {
    title: "Base Color",
    value: "BASE_COLOR",
    icon: "/assets/img/icons/color_icn.svg",
  },
  {
    title: "Add Text",
    value: "ADD_TEXT",
    icon: "/assets/img/icons/text_icn.svg",
  },
  // {
  //   title: "Add Clipart",
  //   value: "ADD_CLIPART",
  //   icon: "/images/icons/image_icn.svg",
  // },
  {
    title: "Add Image",
    value: "UPLOAD",
    icon: "/assets/img/icons/image_icn.svg",
  },
]
